import React, { useState, Component } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { OverlayTrigger, Tooltip as TooltipBootstrap } from 'react-bootstrap';

class Panel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      clickExpanded: false,
    };
  }

  componentDidMount() {
    const { expanded } = this.props;

    this.setState({ clickExpanded: expanded });
  }

  get hasError() {
    const hasError = $(this.refAccordion).has('.error > small');
    return hasError.length > 0;
  }

  renderPanel() {
    const { title, children } = this.props;
    const { clickExpanded } = this.state;
    const { expandedFix } = this.props;

    return (
      <div style={{ width: '100%', marginTop: 10 }}>
        <ExpansionPanel expanded={expandedFix ? true : !clickExpanded ? this.hasError : true}>
          <ExpansionPanelSummary
            expandIcon={!expandedFix ? <ExpandMoreIcon /> : ''}
            onClick={() => this.setState({ clickExpanded: !clickExpanded })}
          >
            <Typography
              style={{
                fontSize: '18px',
                fontWeight: 'bold',
                color: '#3f51b5',
              }}
            >
              {title}
            </Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails style={{ display: 'block' }} ref={(e) => (this.refAccordion = e)}>
            {children}
          </ExpansionPanelDetails>
        </ExpansionPanel>
      </div>
    );
  }

  render() {
    const { title, Tooltip } = this.props;

    return (
      <>
        {Tooltip && (
          <OverlayTrigger
            key={`top-${title}`}
            placement={'top'}
            overlay={
              <TooltipBootstrap id={`tooltip-${title}`}>
                <div className={'fontTooltip'}>{Tooltip || title}</div>
              </TooltipBootstrap>
            }
          >
            {this.renderPanel()}
          </OverlayTrigger>
        )}
        {!Tooltip && this.renderPanel()}
      </>
    );
  }
}

export default Panel;
